import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Flex, Image, Spinner, Text } from '@chakra-ui/react'

import { useCollection } from '@/api/collections'
import AppNavbar from '@/components/app-navbar'
import IconUpload from '@/components/icons/IconUpload'
import Breadcrumbs from '@/components/ui/Breadcrumbs'
import Button from '@/components/ui/Button'
import { H2 } from '@/components/ui/Headings'
import CollectionGraphics from './components/collection-graphics'
import UploadGraphicsModal from './components/upload-graphics-modal'

export default function CollectionPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [isUploadGraphicsModalOpen, setIsUploadGraphicsModalOpen] =
    useState(false)
  const { data: collection, isLoading } = useCollection(id!)

  if (isLoading) {
    return (
      <Box minH="100vh" bg="bg.primary">
        <AppNavbar />
        <Flex justify="center" align="center" minH="400px">
          <Spinner size="xl" color="accent.500" />
        </Flex>
      </Box>
    )
  }

  if (!collection) {
    return (
      <Box minH="100vh" bg="bg.primary">
        <AppNavbar />
        <Flex justify="center" align="center" minH="400px">
          <Text textStyle="body" color="text.secondary">
            Collection not found
          </Text>
        </Flex>
      </Box>
    )
  }

  return (
    <Box minH="100vh" bg="bg.primary">
      <AppNavbar />

      <Box position="relative" h="348px" overflow="hidden">
        {collection.cardImageUrl ? (
          <Image
            src={collection.cardImageUrl}
            alt={collection.name}
            w="100%"
            h="100%"
            objectFit="cover"
          />
        ) : (
          <Box w="100%" h="100%" bg="bg.tertiary" />
        )}

        <Box
          position="absolute"
          top={0}
          left={0}
          w="52%"
          h="100%"
          bgGradient="to-r"
          gradientFrom="bg.primary"
          gradientTo="transparent"
        />

        <Box
          position="absolute"
          top={0}
          right={0}
          w="31%"
          h="100%"
          bgGradient="to-l"
          gradientFrom="bg.primary"
          gradientTo="transparent"
        />

        <Breadcrumbs
          position="absolute"
          top="24px"
          left="32px"
          items={[
            { label: 'IP Library', onClick: () => navigate('/library') },
            { label: collection.name }
          ]}
        />

        <Flex
          position="absolute"
          bottom="36px"
          left="32px"
          maxW="464px"
          direction="column"
          gap="16px"
        >
          <H2 color="white" fontWeight={700}>
            {collection.name}
          </H2>
          <Button
            variant="primary"
            w="fit-content"
            h="46px"
            borderRadius="8px"
            onClick={() => setIsUploadGraphicsModalOpen(true)}
          >
            <Flex align="center" gap="8px">
              <IconUpload boxSize="20px" />
              Upload Graphics
            </Flex>
          </Button>
        </Flex>
      </Box>

      <CollectionGraphics
        collectionId={id!}
        onClickUpload={() => setIsUploadGraphicsModalOpen(true)}
      />

      <UploadGraphicsModal
        isOpen={isUploadGraphicsModalOpen}
        onClose={() => setIsUploadGraphicsModalOpen(false)}
        collectionId={id!}
      />
    </Box>
  )
}
